window.addEventListener("load", () => {

	$('.js-fv-slider').slick({
		arrows: false,
		infinite: true,
		speed: 800,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnFocus: false,
		pauseOnHover: false,
	});

	// GSAP Animation

	// Fade in
	gsap.utils.toArray(".js-fade-in").forEach(target => {
		gsap.fromTo(target, {
			autoAlpha: 0,
		},
			{
				autoAlpha: 1,
				duration: 1,
				scrollTrigger: {
					trigger: target,
					start: "top center",
				},
			}
		);
	});

	// Fade in　up
	gsap.utils.toArray(".js-fade-in-up").forEach(target => {
		gsap.fromTo(target, {
			y: 20,
			autoAlpha: 0,
		},
			{
				y: 0,
				autoAlpha: 1,
				duration: 0.8,
				scrollTrigger: {
					trigger: target,
					start: "top center",
				},
			}
		);
	});

	// Fade in (stagger)
	gsap.utils.toArray(".js-fade-in-stagger-wrap").forEach(wrapper => {
		const targets = wrapper.querySelectorAll(".js-fade-in-stagger");
		gsap.fromTo(targets, {
			y: 20,
			autoAlpha: 0,
		},
			{
				y: 0,
				autoAlpha: 1,
				stagger: 0.4,
				duration: 0.8,
				scrollTrigger: {
					trigger: wrapper,
					start: "top center",
				},
			}
		);
	});

	// parallax
	gsap.utils.toArray(".js-parallax").forEach(wrapper => {
		const yPercent = Number(wrapper.dataset.ypercent);
		const targets = wrapper.querySelectorAll("img");
		gsap.fromTo(targets,
			{
				yPercent: 0,
			},
			{
				yPercent: yPercent,
				ease: "none",
				scrollTrigger: {
					trigger: wrapper,
					start: "top bottom",
					end: "bottom top",
					scrub: 1,
				},
			}
		);
	});

	$('.js-fv-slider').on('init', function () {
		ScrollTrigger.refresh();
	});

	// 直リンク(#hash)対応
	// slick初期化やアニメでレイアウト高さが確定する前にブラウザがスクロール位置を
	// 決めてしまい、目的のセクションではなく最下部などへ飛ぶのを防ぐ。
	// 初期化・レイアウト確定後に、正しいアンカー位置へ瞬時に補正する。
	const scrollToHash = () => {
		if (!window.location.hash) return;
		let target;
		try {
			target = document.querySelector(window.location.hash);
		} catch (e) {
			return;
		}
		if (!target) return;
		const root = document.documentElement;
		const prev = root.style.scrollBehavior;
		root.style.scrollBehavior = 'auto';
		target.scrollIntoView();
		root.style.scrollBehavior = prev;
	};

	if (window.location.hash) {
		ScrollTrigger.refresh();
		scrollToHash();
		// 画像読み込みなど遅延するレイアウト変化にも追従して再補正
		setTimeout(() => {
			ScrollTrigger.refresh();
			scrollToHash();
		}, 300);
	}

	// 以降のアンカークリックはなめらかにスクロール（動きを減らす設定は尊重）
	if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		document.documentElement.style.scrollBehavior = 'smooth';
	}

});
